import { Group, NavLink, Text } from '@mantine/core'
import { observer } from 'mobx-react-lite'

import { FaIcon } from '#components/FaIcon'
import { useFormattedTimestamp, useNavigation } from '#hooks'
import { IListing, isScriptListing } from '#state/types'

import styles from './DocumentRow.module.css'

type DocumentRowProps = {
  listing: IListing
}

export const DocumentRow = observer(function DocumentRow({
  listing,
}: DocumentRowProps) {
  const { navigateToScript, navigateToRundown } = useNavigation()

  const icon = isScriptListing(listing)
    ? (listing.icon as `fa-${string}`)
    : 'fa-table-cells'

  const formattedTimestamp = useFormattedTimestamp({
    date: listing.contentsModifiedAt,
    user: listing.lastModifier?.name,
  })

  const handleClick = () => {
    if (isScriptListing(listing)) {
      navigateToScript(listing.id, undefined, { source: 'dashboard' })
    } else {
      navigateToRundown(String(listing.id), { source: 'dashboard' })
    }
  }

  return (
    <NavLink
      classNames={styles}
      onClick={handleClick}
      label={
        <Group gap="xs" wrap="nowrap">
          <FaIcon span icon={icon} size="sm" className={styles.icon} />
          <Text className={styles.title} span truncate>
            {listing.name}
          </Text>
        </Group>
      }
      description={formattedTimestamp}
      noWrap
    />
  )
})
